// OneDrive:IgnoreCodeCoverage

import { createPairedEvent } from '../PairedEventBase';
import { IEventType } from '../EventBase';
import { IEvent, EventFieldType } from '../IEvent';
import { IPairedEventEndData } from '@ms/telemetry-manager/lib/IPairedEventEndData';
export interface IBeaconStartSchema {
    /**
     * This is the status code returned
     */
    name?: string;
    /**
     * This is the status code returned
     */
    status?: string;
    /**
     * This is if the request was successful or not
     */
    success?: boolean;
    /**
     * This is the retry count for this request
     */
    retryCount: number;
    /**
     * This is the number of total retries left
     */
    totalRetries: number;
    /**
     * This is the number of total events sent
     */
    eventCount?: number;
}

export interface IBeaconEndSchema extends IPairedEventEndData {
    /**
     * This is the status code returned
     */
    name?: string;
    /**
     * This is the status code returned
     */
    status?: string;
    /**
     * This is if the request was successful or not
     */
    success: boolean;
    /**
     * This is the retry count for this request
     */
    retryCount?: number;
    /**
     * This is the number of total retries left
     */
    totalRetries?: number;
    /**
     * This is the number of total events sent
     */
    eventCount?: number;
}

export interface IBeacon extends IEvent {
    data: IBeaconStartSchema & IBeaconEndSchema;
    /**
     * This writes verbose logs to memory to be uploaded if event ends with failure.
     */
    verbose(message: string): void;
    /**
     * Sets a time limit for the scenario. A timeout result will be logged if no end happens in desired timeframe.
     */
    setTimeout(ms: number, data: IBeaconEndSchema): void;

    /**
     * This will end the Beacon event
     * @param data {IBeaconEndSchema}     * -optional name - This is the status code returned
     * -optional status - This is the status code returned
     * -required success - This is if the request was successful or not
     * -optional eventCount - This is the number of total events sent
     */
    end(data: IBeaconEndSchema): void;
}

export type Beacon = IBeacon;

export const Beacon: IBeaconType = createPairedEvent<IBeaconStartSchema, IBeaconEndSchema>({
    eventName: 'Beacon,',
    shortEventName: 'Beacon',
    requiresParent: false
}, {
        name: EventFieldType.String,
        status: EventFieldType.String,
        success: EventFieldType.Boolean,
        retryCount: EventFieldType.Number,
        totalRetries: EventFieldType.Number,
        eventCount: EventFieldType.Number
    });

export interface IBeaconType extends IEventType<IBeaconStartSchema & IBeaconEndSchema> {
    prototype: Beacon;
    /**
     * The Beacon event constructor
     * @param data {IBeaconStartSchema}     * -optional name - This is the status code returned
     * -optional status - This is the status code returned
     * -optional success - This is if the request was successful or not
     * -required retryCount - This is the retry count for this request
     * -required totalRetries - This is the number of total retries left
     * -optional eventCount - This is the number of total events sent
     * @param parent {IEvent} The optional parent for this event
     */
    new(data: IBeaconStartSchema, parent?: IEvent): Beacon;
}

export default Beacon;
